import { SharedDialogAlertStyling } from "./index.styled.mjs";
import { NavPill } from "../../../core/components/NavPill/index.mjs";
import { NavPillList } from "../../../core/components/NavPillList/index.mjs";
import { NavPillPanel } from "../../../core/components/NavPillPanel/index.mjs";
import { Type } from "../../../core/components/Type/index.mjs";
import styled from "../../../core/styled-components.mjs";
import { cssColorValue, cssSpacing, semanticColors } from "../../../core/styles/index.mjs";
export var StyledNavPill = styled(NavPill).withConfig({
  displayName: "DeliveryInfoTabsstyled__StyledNavPill",
  componentId: "sc-1eta234-0"
})(["", ";margin-top:20px;"], SharedDialogAlertStyling);
export var StyledNavPillList = styled(NavPillList).withConfig({
  displayName: "DeliveryInfoTabsstyled__StyledNavPillList",
  componentId: "sc-1eta234-1"
})(["", ";margin-bottom:20px;"], SharedDialogAlertStyling);
export var StyledNavPillPanel = styled(NavPillPanel).withConfig({
  displayName: "DeliveryInfoTabsstyled__StyledNavPillPanel",
  componentId: "sc-1eta234-2"
})(["word-wrap:break-word;"]);
export var FileNamesContainer = styled.div.withConfig({
  displayName: "DeliveryInfoTabsstyled__FileNamesContainer",
  componentId: "sc-1eta234-3"
})(["", ";padding-bottom:20px;background-color:", ";"], SharedDialogAlertStyling, cssColorValue(semanticColors.backgroundTintedBase));
export var FilesFoundLabel = styled(Type.p).attrs({
  variant: 'violaBold'
}).withConfig({
  displayName: "DeliveryInfoTabsstyled__FilesFoundLabel",
  componentId: "sc-1eta234-4"
})(["padding-top:20px;padding-bottom:", ";margin-left:20px;"], cssSpacing('tighter', '12px'));
export var FileName = styled(Type.p).withConfig({
  displayName: "DeliveryInfoTabsstyled__FileName",
  componentId: "sc-1eta234-5"
})(["margin-left:20px;font-size:12px;color:", ";padding-right:20px;"], cssColorValue(semanticColors.textSubdued));